/**
 * Templates AI Edit Feature Registration
 *
 * Defines the feature configuration for auto-registration with the Redux store.
 */

import type { FeatureModule } from '@store/features/types';

import { templateBuildSlice } from './chatSlice';
import { templateBuildStreamingApi } from './streamingApi';

/**
 * Templates AI Edit feature definition
 */
export const templatesAiEditFeature: FeatureModule = {
  id: 'templatesAiEdit',
  name: 'Templates AI Edit',
  dependencies: [],

  reducers: {
    'templatesAiEdit/ui': templateBuildSlice.reducer,
    [templateBuildStreamingApi.reducerPath]: templateBuildStreamingApi.reducer,
  },

  // Important: This feature adds its own RTK Query middleware
  // because it uses a separate streaming API instance with fakeBaseQuery
  middleware: [templateBuildStreamingApi.middleware],

  persistence: {
    enabled: false, // Don't persist streaming state
  },

  sync: {
    enabled: false,
  },

  setup: _store => {
    // Initialization logic if needed
  },

  cleanup: _store => {
    // Cleanup logic if needed
  },
};

